/**
 * account.js: Feature level module
 * @description This module is used for:
 *              1. Sign In / Create Account
 *              2. Forgot Password
 *              3. My Account sub pages including
 *                3.1. Account Details
 *                3.2. Address Book
 *                3.3. Payment Method
 *                3.4. My Orders
 *                3.5. Wish Lists
 *                3.6. Shopping Lists
 */

define(['logon', 'membershipNumber', 'accountHelper', 'product_helper','addressBook','preferences','renewMembership','paymentMethods','accountDetails', 'businessDetails', 'addAdditionalPeople', 'accountDetailsUpdatePass', 'myOrdersFSA', 'membershipValidation', 'registerUser', 'costcoPayFob','costcoPayAccountInformation','costcoPayTransactionHistory', 'secureKeyMemberVerification', 'timeoutModal', 'digitalMembershipCard', 'memberVerification'], 
		function(logon, membershipNumber, accountHelper, phelper, addressBook, preferences,renewMembership,paymentMethods,accountDetails, businessDetails, addAdditionalPeople, accountDetailsUpdatePass, myOrdersFSA, membershipValidation, registerUser, costcoPayFob, costcoPayAccountInformation, costcoPayTransactionHistory, secureKeyMemberVerification, timeoutModal, digitalMembershipCard, memberVerification) {

	let Account = {
			
			formValid: "",
	  /**
	   * Initializes the appropriate submodules for the account feature.
	   * @return {void}
	   */
	  init: function() {
		  	$(document).keyup(function(e) {
			  if (e.keyCode == 27) { //27 = keycode for escape
			     //Hide tooltip here
				 $("div[role='tooltip']").hide();
			  }   
			});
			accountHelper.init();
		    let page = $('[data-page]').data('page') || '';
		    switch (page) {
		      case 'Home,MyAccount,Preferences':
		        preferences.init();
		        break;
			  case 'Home,MyAccount,RenewMembership':
				renewMembership.init();
				break;	
		      case 'Home,MyAccount,PaymentMethods':
		          paymentMethods.init();
		          break;
		      case 'Home,MyAccount,AccountAddressBook':
		    	  addressBook.init();
		    	  break;
		      case 'Home,MyAccount,AccountDetails':
		    	  accountDetails.init();
		    	  break;
	          case 'Home,MyAccount,OrderStatus,FSAOrders':
	        	  myOrdersFSA.init();
	        	  break;
	          case 'Home,MyAccount,OrderStatus':
	        	  memberVerification.init();
	        	  break;
		      case 'Home,MyAccount,UpdatePassword':
		    	  accountDetailsUpdatePass.init();
		    	  break;
		      case 'Home,MyAccount,BusinessDetails':
		    	  businessDetails.init();
		    	  break;
		      case 'Home,MyAccount,BusinessDetails,AddAdditionalPeople':
		    	  addAdditionalPeople.init();
		    	  break;
		      case 'RegisterUser':
		    	  registerUser.init();
		    	  break;
		      case 'LinkMembershipInterrupt':
		      case 'SecondaryValidation':
		      case 'CanceledMembership':
		    	  $('.co-help').popover();
		    	  membershipValidation.init();
		    	  secureKeyMemberVerification.init();
		    	  break;
		      case 'ValidationExceedAttempts':
		    	  membershipValidation.init();
		    	  secureKeyMemberVerification.init();
		    	  break;
		      case 'Home,MyAccount,CostcoPay':
		    	  membershipValidation.init();
		    	  costcoPayAccountInformation.init();
		    	  costcoPayFob.init();
		    	  costcoPayTransactionHistory.init();
		    	  break;	
		      case 'verify-membership' :
		    	  secureKeyMemberVerification.init();
		    	  break;
		      case 'Home,MyAccount,DigitalMembershipCard':
		    	  digitalMembershipCard.init();
			        break;
		      default:
		        membershipNumber.init();
			    logon.init();
		    } 
			
		    accountHelper.reinitDropDownMenu();
			accountHelper.activateDropdownMenuRedirect();
			accountHelper.addAdaComplianceOnLeftNabarForAccount();		    
		    Account.validateAccountRules();
		    Account.registerEvents();
		    COSTCO.dialog.initializeReturnFocusListener();
		    COSTCO.timeoutModal.init();
	},
	
	validateAccountRules: function() {
		$.validator.addMethod('email', function(value, element) {
	        return this.optional(element) || /^.+@(([^.])+\.)+([^.])+$/i.test(value);
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
		$.validator.addMethod('singleemail', function(value, element) {
	        let flag = true;
	        flag = flag && /^\s*((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?\s*$/.test(value.toLowerCase());
	        return this.optional(element) || flag;
	      }, messages.ERR_INVALID_EMAIL_ADDRESS);
	      $.validator.addMethod('membershipNumber', function(value, element) {
	        // costco pins are 12 digits
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.MEMBERVERIFICATION_MEMBERSHIP__InvalidMembershipNumber);
	      $.validator.addMethod('costcoMembership', function(value, element) {
	        return this.optional(element) || /^\d{12,16}$/.test(value);
	      }, messages.ERR_INVALID_MEMBERSHIP_BD);
	     
	      Account.formValid = $('.accountEmailForm').validate({
	    	errorClass: "h8-style-guide error-membership",
		    rules: {
	    	  email: {
		        required: true,
		        email: true,
		        singleemail: true,
		        maxlength: 251
		      },
		      email1: {
		        required: true,
		        email: true,
		        singleemail: true,
		        maxlength: 251
		      },
		      userField2: {
		    	  required: true,
		    	  costcoMembership:true,
		      },
		       
		    },
		    messages: {
		    email: {
		        required: messages.JS_VALID_REQUIRED,
		        email: messages.ERR_INVALID_EMAIL_ADDRESS,
		        singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
		        maxlength: messages.ERR_EMAIL_MAX_LENGTH
		      },
		      email1: {
		        required: messages.JS_VALID_REQUIRED,
		        email: messages.ERR_INVALID_EMAIL_ADDRESS,
		        singleemail: messages.ERR_INVALID_EMAIL_ADDRESS,
		        maxlength: messages.ERR_EMAIL_MAX_LENGTH
		      },
		     userField2: {
		          required: messages.ERR_INVALID_MEMBERSHIP_BD,
		          costcoMembership: messages.ERR_INVALID_MEMBERSHIP_BD,
		      },
		    },
			 submitHandler: function(form) {
		    	form.submit();
		      }.bind(this),
		  });
	    },

	registerEvents : function(){
		 $(".editMembershipNumber").on("click", function (e) {
		     e.preventDefault();
		     Account.memberShipUpdateEnable();
		 });
		 $(".editEmailAddress").on("click", function (e) {
			 e.preventDefault();
			$("#emailEditLink").hide();
			$(".email-box-label").hide();
		    $("input.email-input-field").val($(".email-box-label").text());
		    $("input.email-input-field").show();
		    $("button.update-email-button").show();
		    
		 });
		 
		 $(".update-email-button").on("click", function (e) {
			 if ($('.accountEmailForm').valid()){
			 e.preventDefault();
			 COSTCO.dialog.createExtDialogBox({
				title :  messages.CHANGE_EMAIL_NOTIFICATION_TITLE,
				body : messages.CHANGE_EMAIL_NOTIFICATION_TEXT,
				primary: messages.CHANGE_EMAIL_NOTIFICATION_CONT,
				primary_event: function(){
					$("#emailEditLink").hide();
					$(".email-box-label").hide();
				    $("button.update-email-button").hide();
				    COSTCO.dialog.close();
				    $('.accountEmailForm').submit();
				}
			});
			 }
		 });
		 
		$(".editPreferenceEmail").on("click", function (e) {
			e.preventDefault(); 
			$("#emailEditLink").hide();
			$('.editPreferenceEmail').hide();
			$(".email-box-label").hide();
		    $("input.email-input-field").val($(".email-box-label").text());
		    $("input.email-input-field").show();
		    $("button.update-preference-email-button").show();

			 });		    
		 $("#receiveMail").on("change", function (e) {
		   $("#sendMeEmail").val(!this.checked);  
		 });  
		
	},
	memberShipUpdateEnable :function(){
	     $("#membershipEditLink").hide();
	     $(".member-box-label").hide();
	     $("input.member-input-field").val($(".member-box-label").text());
	     $("input.member-input-field").show();
	     $("button.update-member-button").show();
	}
		
	}		
	$(window).on('load',function() {
	     if($('input[name=userField2]').val()==''){
	    	 Account.memberShipUpdateEnable();
	     }
	     if($('#errForEmail').val()=='true'){
	    	 $('#emailEditLink').click();
	     }
   	});
	
	if (typeof window.COSTCO == 'undefined') {
		window.COSTCO = {};
	}
	if (typeof window.COSTCO.Global == 'undefined') {
		document.addEventListener('CostcoGlobalLoaded', Account.init, false);
	} else {
		Account.init();
	}
	window.COSTCO.Account = Account;
  	return Account;
});






// WEBPACK FOOTER //
// ./js/account/account.js